export default __webpack_public_path__ + "static/media/ill-fm-kyc.35d8321f.svg";